export enum PermissionConsts {
    // Pages
    Pages_Tenants = 'Pages.Tenants',
    Pages_Roles = 'Pages.Roles',
    Pages_Users = 'Pages.Users',
    Pages_Users_Activation = 'Pages.Users.Activation',
    //endregion Pages

    //region Users
    User_RequestEmailConfirmation = 'User.RequestEmailConfirmation',
    User_Create = 'User.Create',
    User_Get = 'User.Get',
    User_Edit = 'User.Edit',
    User_Delete = 'User.Delete',
    User_ForceResetPassword = 'User.ForceResetPassword',
    User_Deactivate = 'User.Deactivate',
    User_UnlockLogin = 'User.UnlockLogin',
    User_MyProfile = 'User.MyProfile',
    User_GetAllOperatorHours = 'User.GetAllOperatorHours',
    User_ExportOperatorHoursCsv = 'User.ExportOperatorHoursCsv',
    User_UpdateWeeklyHours = 'User.UpdateWeeklyHours',
    //endregion User

    //region OperatorAbsence
    OperatorAbsence_GetAll = 'OperatorAbsence.GetAll',
    OperatorAbsence_Create = 'OperatorAbsence.Create',
    OperatorAbsence_Delete = 'OperatorAbsence.Delete',
    //endregion OperatorAbsence

    //region Location
    Location_Create = 'Location.Create',
    Location_Get = 'Location.Get',
    Location_GetAll = 'Location.GetAll',
    Location_Update = 'Location.Update',
    Location_Delete = 'Location.Delete',
    //endregion Location

    // Roles
    Role_Create = 'Role.Create',
    Role_Update = 'Role.Update',
    Role_Get = 'Role.Get',
    Role_GetAll = 'Role.GetAll',
    Role_Delete = 'Role.Delete',
    //endregion

    // Files
    File_List = 'File.List',
    File_Detail = 'File.Detail',
    File_Create = 'File.Create',
    File_Delete = 'File.Delete',
    File_Export = 'File.Export',
    //endregion

    // Exercise
    Exercise_Create = 'Exercise.Create',
    Exercise_Get = 'Exercise.Get',
    Exercise_GetAll = 'Exercise.GetAll',
    Exercise_Update = 'Exercise.Update',
    Exercise_Delete = 'Exercise.Delete',
    //endregion

    // Method
    Method_Create = 'Method.Create',
    Method_Get = 'Method.Get',
    Method_GetAll = 'Method.GetAll',
    Method_Update = 'Method.Update',
    Method_Delete = 'Method.Delete',
    //endregion

    //region Workout
    Workout_Create = 'Workout.Create',
    Workout_Update = 'Workout.Update',
    Workout_Get = 'Workout.Get',
    Workout_GetAll = 'Workout.GetAll',
    Workout_Delete = 'Workout.Delete',
    Workout_Client = 'Workout.Client',
    Workout_Section = 'WorkoutsSection.View',
    //endregion

    // Level
    Level_Create = 'Level.Create',
    Level_Get = 'Level.Get',
    Level_GetAll = 'Level.GetAll',
    Level_Delete = 'Level.Delete',
    // endregion

    // Session
    Session_Create = 'Session.Create',
    Session_Get = 'Session.Get',
    Session_GetAll = 'Session.GetAll',
    Session_Delete = 'Session.Delete',
    Session_ExportPdf = 'Session.ExportPdf',
    //endregion

    //region Sequence
    Sequence_Create = 'Sequence.Create',
    Sequence_Update = 'Sequence.Update',
    Sequence_Get = 'Sequence.Get',
    Sequence_GetAll = 'Sequence.GetAll',
    Sequence_Delete = 'Sequence.Delete',
    //endregion

    //region Route
    Route_Create = 'Route.Create',
    Route_Update = 'Route.Update',
    Route_Delete = 'Route.Delete',
    Route_GetAll = 'Route.GetAll',
    Route_Get = 'Route.Get',
    //endregion

    //region customer
    Customer_Create = 'Customer.Create',
    Customer_Get = 'Customer.Get',
    Customer_GetAll = 'Customer.GetAll',
    Customer_Update = 'Customer.Update',
    Customer_Delete = 'Customer.Delete',
    CustomerAdditionalData_GetAll = 'CustomerAdditionalData.GetAll',
    CustomerAdditionalData_Update = 'CustomerAdditionalData.Update',
    CustomerAdditionalData_Get = 'CustomerAdditionalData.Get',
    CustomerAdditionalData_Delete = 'CustomerAdditionalData.Delete',
    CustomerAdditionalData_Create = 'CustomerAdditionalData.Create',
    //endRegion

    // region acuteEvent
    AcuteEvent_Create = 'AcuteEvent.Create',
    AcuteEvent_Get = 'AcuteEvent.Get',
    AcuteEvent_Update = 'AcuteEvent.Update',
    AcuteEvent_Delete = 'AcuteEvent.Delete',
    AcuteEvent_Export = 'AcuteEvent.Export',
    AcuteEvent_GetAll = 'AcuteEvent.GetAll',
    // endRegion

    // region customerReport
    CustomerReport_Create = 'CustomerReport.Create',
    CustomerReport_Update = 'CustomerReport.Update',
    CustomerReport_Delete = 'CustomerReport.Delete',
    CustomerReport_Get = 'CustomerReport.Get',
    CustomerReport_GetAll = 'CustomerReport.GetAll',
    // endRegion

    // region Rehabilitation
    Rehabilitation_Create = 'Rehabilitation.Create',
    Rehabilitation_Update = 'Rehabilitation.Update',
    Rehabilitation_Delete = 'Rehabilitation.Delete',
    Rehabilitation_Get = 'Rehabilitation.Get',
    Rehabilitation_GetAll = 'Rehabilitation.GetAll',
    // endRegion

    // region customerAMA
    CustomerAMA_Create = 'CustomerAMA.Create',
    CustomerAMA_Update = 'CustomerAMA.Update',
    CustomerAMA_Delete = 'CustomerAMA.Delete',
    CustomerAMA_Get = 'CustomerAMA.Get',
    CustomerAMA_GetAll = 'CustomerAMA.GetAll',
    // endRegion

    // region routeCustomer
    RouteCustomer_Create = 'RouteCustomer.Create',
    RouteCustomer_Update = 'RouteCustomer.Update',
    RouteCustomer_Delete = 'RouteCustomer.Delete',
    RouteCustomer_Get = 'RouteCustomer.Get',
    RouteCustomer_GetAll = 'RouteCustomer.GetAll',
    // endRegion

    // region test
    Test_Create = 'Test.Create',
    Test_Delete = 'Test.Delete',
    Test_Get = 'Test.Get',
    Test_GetAll = 'Test.GetAll',
    Test_Update = 'Test.Update',
    // endRegion

    // region testCycle
    TestCycle_Create = 'TestCycle.Create',
    TestCycle_Update = 'TestCycle.Update',
    TestCycle_Delete = 'TestCycle.Delete',
    TestCycle_Get = 'TestCycle.Get',
    TestCycle_GetAll = 'TestCycle.GetAll',
    // endRegion

    // region trial
    Trial_Create = 'Trial.Create',
    Trial_Delete = 'Trial.Delete',
    Trial_Get = 'Trial.Get',
    Trial_GetAll = 'Trial.GetAll',
    Trial_Update = 'Trial.Update',
    // endRegion

    // region activity
    Activity_Create = 'Activity.Create',
    SlotOperator_GetAll = 'SlotOperator.GetAll',
    SlotOperator_Assign = 'SlotOperator.Assign',
    SlotOperator_Unassign = 'SlotOperator.Unassign',
    SlotOperator_Reset = 'SlotOperator.Reset',
    SlotGeneration_Delete = 'SlotGeneration.Delete',
    Activity_Update = 'Activity.Update',
    Activity_Delete = 'Activity.Delete',
    Activity_Get = 'Activity.Get',
    Activity_GetAll = 'Activity.GetAll',
    // endRegion

    // HealthMetric
    HealthMetric_Create = 'HealthMetric.Create',
    HealthMetric_Update = 'HealthMetric.Update',
    HealthMetric_Get = 'HealthMetric.Get',
    HealthMetric_GetAll = 'HealthMetric.GetAll',
    HealthMetric_Delete = 'HealthMetric.Delete',
    // endRegion

    // Subscription
    Subscription_Create = 'Subscription.Create',
    Subscription_Update = 'Subscription.Update',
    Subscription_Delete = 'Subscription.Delete',
    SubscriptionSessionCancellationReason_Create = 'SubscriptionSessionCancellationReason.Create',
    SubscriptionSessionCancellationReason_Delete = 'SubscriptionSessionCancellationReason.Delete',
    // endRegion

    // Notification
    Notifications_Create = 'Notifications.Create',
    Notifications_View = 'Notifications.View',
    // endRegion
}
